import { EntitySchema, EventSchema } from '@nrk/snowplow-web';

/**
 * Root path to snowplow bundle on static.nrk.no.
 */
var staticSnowplowRoot = "https://static.nrk.no/nrkno-snowplow";
/**
 * The current major version
 */
var staticSnowplowMajorVersion = "1";

//@ts-expect-error post-fix version to allow multiple versions to co-exists at the same time
var globalKey = "nrknoOnTrackerReady-" + staticSnowplowMajorVersion;

/**
 * Modified version of @nrk/snowplow-web. Does not allow array or undefined
 */

/**
 * Typecheck and generate `{schema, data}`
 */
function getTyped(schema, data) {
  return {
    schema,
    data
  };
}

/**
 * No-op type check
 */
function isTypedContext(_schema, _data) {}
/**
 * No-op type check
 */
function isTypedEvent(_schema, _data) {}
/**
 * No-op type check
 */
function isTyped(_schema, _data) {}

/**
 * No-op type check
 */
function isTypedArray(_schema, _data) {}

/**
 * Typechecks a context and return the Snowplow type
 */
function asSnowplowContext(data) {
  return data;
}
function asSnowplowEntity(data) {
  return data;
}

var typeUtil = /*#__PURE__*/Object.freeze({
  __proto__: null,
  EntitySchema: EntitySchema,
  EventSchema: EventSchema,
  asSnowplowContext: asSnowplowContext,
  asSnowplowEntity: asSnowplowEntity,
  getTyped: getTyped,
  isTyped: isTyped,
  isTypedArray: isTypedArray,
  isTypedContext: isTypedContext,
  isTypedEvent: isTypedEvent
});

/// <reference types="vite/client" />
/**
 * Takes a callback that will be called with the bundled JS when ready.
 *
 * This function will load the major version (defined above in JS file) from `static.nrk.no`
 * @note the callback will never be called if a network error occurs.
 */
function getBundle(callback) {
  // Add callback queue placeholder if needed
  if (globalThis[globalKey] === undefined) {
    //@ts-expect-error `q` is next line
    globalThis[globalKey] = function (cb) {
      globalThis[globalKey].q.push(cb);
    };
    globalThis[globalKey].q = [];
  }
  {
    // load script if needed
    loadOnce(staticSnowplowRoot + "/major/" + staticSnowplowMajorVersion + "/nrkno-snowplow-entry.js");
  }

  // add callback
  globalThis[globalKey](callback);
}
/**
 * loadOnce loads the given script IFF it is not already present in the DOM.
 * @param {string} src URL for script
 * @returns {undefined}
 */
function loadOnce(src) {
  var hasScript = document.querySelector("script[src=\"" + src + "\"]");
  if (hasScript) {
    return;
  }
  var script = document.createElement('script');
  script.async = true;
  script.src = src;
  document.head.appendChild(script);
}

export { typeUtil as TypeUtils, getBundle };
